export default "__VITE_ASSET__CGFIDwE5__"